const resetUser = () => ({ type: "RESET_USER" });
export default resetUser;
